import { useEffect } from 'react';
import DSBox from '../../../../../design-system/DSBox';
import { DSTypography } from '../../../../../design-system/Typography';
import DSCircularProgress from '../../../../../design-system/DSCircularProgress';
import usePlansQuery, { usePlanByIdQuery } from '../../../hooks/usePlansQuery';
import PlanCard from '../../PlanCard';

type CollectionMonetizationTabProps = {
  selectedPlanId: string | null;
  assignedPlanId: string | null;
  onSelectPlan: (planId: string) => void;
};

const CollectionMonetizationTab = ({
  selectedPlanId,
  assignedPlanId,
  onSelectPlan,
}: CollectionMonetizationTabProps) => {
  useEffect(() => {
    if (assignedPlanId) {
      onSelectPlan(assignedPlanId);
    }
  }, [assignedPlanId]);

  const { data: plans, isLoading } = usePlansQuery({
    enabled: !assignedPlanId,
  });
  const { data: assignedPlan, isLoading: isLoadingAssignedPlan } =
    usePlanByIdQuery(assignedPlanId);

  if (assignedPlanId ? isLoadingAssignedPlan : isLoading) {
    return (
      <DSBox sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <DSCircularProgress size={24} />
      </DSBox>
    );
  }

  if (assignedPlanId) {
    return (
      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: '80%',
        }}
      >
        <DSTypography variant="h5">Your monetization plan:</DSTypography>
        {assignedPlan && (
          <DSBox
            sx={{ display: 'flex', height: '291px', width: 'calc(33% - 10px)' }}
          >
            <PlanCard plan={assignedPlan} selected={false} />
          </DSBox>
        )}
      </DSBox>
    );
  }

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        width: '80%',
      }}
    >
      <DSTypography variant="h5">Choose your payment plan</DSTypography>
      <DSBox
        sx={{
          display: 'flex',
          gap: '31px',
          alignItems: 'stretch',
          height: '291px',
          width: '100%',
        }}
      >
        {plans?.map((plan) => (
          <PlanCard
            key={plan.id}
            plan={plan}
            selected={selectedPlanId === plan.id}
            onClick={() => onSelectPlan(plan.id)}
          />
        ))}
      </DSBox>
    </DSBox>
  );
};

export default CollectionMonetizationTab;
